import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'

import StylesModule from 'components/lv2/NumHeadlineText.module.scss'
import Logo from 'images/logo-only-glay.svg'

export interface NumHeadlineTextProps {
  num: string
  headline: string
  text: string
}

const useStyles = makeStyles(() => ({
  bgImage: {
    backgroundImage: `url(${Logo})`,
    backgroundRepeat: `no-repeat`,
    backgroundPosition: `top center`,
  },
}))

const NumHeadlineText: FC<NumHeadlineTextProps> = ({ num, headline, text }) => {
  const classes = useStyles()
  return (
    <div
      className={classNames(
        classes.bgImage,
        StylesModule.numHeadlineText,
        'mt-80',
      )}
    >
      <div className={StylesModule.numHeadlineText__numTitle}>
        <div className={StylesModule.numHeadlineText__num}>{num}</div>
        <h1 className={StylesModule.numHeadlineText__title}>{headline}</h1>
        <hr
          className={classNames(
            StylesModule.numHeadlineText__bar,
            StylesModule.numHeadlineText__barTop,
          )}
        />
        <hr
          className={classNames(
            StylesModule.numHeadlineText__bar,
            StylesModule.numHeadlineText__barBottom,
          )}
        />
      </div>
      <div
        className={StylesModule.numHeadlineText__text}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  )
}

export default NumHeadlineText
